<template src="@/templates/document/clearanceCheck.html"></template>

<script>
import ClearanceCheckCollection from "@/collections/clearanceCheckCollection";
import ClearanceCheckModel from "@/models/clearanceCheckModel";
import fileView from "@/components/file/FileView";
import { mapActions } from "vuex";

export default {
  name: "clearanceCheck",
  props: ["type", "isEndDate"],
  components: {
    fileView,
  },
  watch: {
    $route: "fetchClearanceCheck",
  },
  data() {
    return {
      clearanceCheckCollection: new ClearanceCheckCollection(),
      clearanceCheckModel: new ClearanceCheckModel(),
      checksTitle: "Working With Children Check",
      viewFileViewComp: false,
      currentFileName: "",
      isThis: "clearanceCheck",
    };
  },
  created() {
    this.fetchClearanceCheck();
  },
  mounted() {
    Event.$on("hideFileViewComp", (isThis) => {
      if (isThis === this.isThis) {
        let thisComponent = this;
        setTimeout(function () {
          thisComponent.viewFileViewComp = false;
        }, 50);
      }
    });

    Event.$on("refreshCheck", () => {
      this.fetchClearanceCheck();
    });
  },
  methods: {
    ...mapActions([
      "updateImageFor",
      "updateNoEndDate",
      "updateResourceCategoryHide",
      "updateIcon",
      "updateCameraState",
      "updateClockOnOffHide",
      "updateAcceptDeclineHide",
      "updateSearchStateHide",
      "updateCameraStateHide",
      "updateBackButton",
    ]),
    fetchClearanceCheck() {
      if (this.type != "" || this.type != undefined) {
        this.updateImageFor(this.type);
      }

      if (this.isEndDate != "" || this.isEndDate != undefined) {
        this.updateNoEndDate(this.isEndDate);
      }

      this.updateIcon(["camera", "file-upload", "sign-in-alt", "sign-out-alt"]);
      this.updateCameraState(true);
      this.updateClockOnOffHide(true);
      this.updateAcceptDeclineHide(true);
      this.updateSearchStateHide(true);
      this.updateResourceCategoryHide(true);
      this.updateCameraStateHide(false);
      this.updateBackButton(false);

      this.clearanceCheckCollection
        .getList(this.type, this.isEndDate)
        .then((clearanceCheckCollectionRes) => {
          this.clearanceCheckCollection.models =
            clearanceCheckCollectionRes.response.data.data;

          if (this.clearanceCheckCollection.models[0] === undefined) {
            this.checksTitle =
              clearanceCheckCollectionRes.response.data.no_data_title;
          } else {
            this.checksTitle = this.clearanceCheckCollection.models[0].title;
          }
        })
        .catch((PCError) => {
          let errorMessage = "Network error. " + PCError;
          this.fetchError(errorMessage);
          console.error(PCError);
        });
    },
    fetchError(errorMessage) {
      this.$vs.notify({
        title: "Network Error",
        text: errorMessage,
        time: 4000,
        color: "danger",
        position: "top-center",
      });
    },
    viewClearanceCheck(model) {
      this.currentFileName = model.file_name;
      this.viewFileViewComp = true;
    },
  },
};
</script>
